<template lang="pug">
  div
    order-step(:current-step="6")
    h2 Bestellung Erfolgreich
    div.px-4.py-4.min-height
      div Vielen Dank! Ihre Bestellung wurde erfolgreich übertragen.
    div.card-footer.text-right
      button.btn.btn-primary.btn-lg(
        type="button"
        @click="showMenu"
        )
        | Zum Menü
</template>

<script>
import { mapActions } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'

export default {
  name: 'OrderSuccess',
  components: {
    OrderStep
  },
  methods: {
    ...mapActions('ui', [
      'showMenu'
    ])
  }
}
</script>
